import { render } from "./TermsAndConditions.vue?vue&type=template&id=7c818d21&scoped=true"
const script = {}

import "./TermsAndConditions.vue?vue&type=style&index=0&id=7c818d21&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7c818d21"

export default script